// Cursors encode the number of records to skip. The first page skips nothing,
// and the API never hands out a zero cursor, so send no cursor at all rather
// than an offset of 0.
export const pageCursor = (pageNumber, itemsPerPage) => {
  const offset = itemsPerPage * (pageNumber - 1);

  return offset > 0 ? btoa(offset) : undefined;
};

// Formats the page data into the following format:
// { after: <startCursor>, first: <numberOfItems> }
// This is to help with pagination in our GraphQL api
export const formatPageData = (pageNumber, itemsPerPage) => {
  return { after: pageCursor(pageNumber, itemsPerPage), first: itemsPerPage };
};
